export const PICK_FROM_STORE = 'PICK_FROM_STORE';
export const SHIP_TO_STORE = 'SHIP_TO_STORE';
export const NONE = 'NONE';
